import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }) => ({
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12
  },
  help: {
    marginTop: 8
  },
  link: {
    color: palette.primary.main,
    textDecoration: 'underline'
  }
}));
